var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).ready(function(){
     /***  on load automatically detect last selected variant *****/ 
  
    // Dog size variants
    if(readCookie("dog_size") == null){
        createCookie("dog_size", "Toy", 30);
    }
    if(readCookie("frequency-one") == null){
    createCookie("frequency-one", "2 Jars", 30);
    }

    if(readCookie("frequency-sub") == null){
    createCookie("frequency-sub", "2 Jars", 30);
    }

    let default_selected_size = readCookie("dog_size");
    function mainVariant(){
        // console.log(default_selected_size);
        
        
        // is_active class added as per selected variant
        setTimeout(function(){
            if($('.form__group.form__group--frequency .form__field').length > 0){
                $(document).find(`.dog-size .form__group.form__group--dog-size .form__field input[data-size-value=${default_selected_size}]`).trigger('click');
                $('.form__group.form__group--frequency .form__field input[name="select-frequency"]:checked').each(function(ie,ix){
                    var get_data = readCookie("dog_size");
                    var get_val = $(ix).attr('data-f-type');
                    if(get_val == 'one-time' )           
                    {
                        $('.frequency-product .frequency-product__row.one-time-section').each(function(ix,ie){
                            var get_title = $(ie).find('.frequency-product__col').attr('data-var-title');
                            if(get_title == get_data){
                            
                                $(ie).addClass('is_active');
                                $(ie).css('display','flex');
                            }else{
                                $(ie).css('display','none');
                                $(ie).removeClass('is_active');
                            }
                        });
                    
                    }else{
                        $('.frequency-product .frequency-product__row.sub-save-section').each(function(ix,ie){
                            var get_title = $(ie).find('.frequency-product__col').attr('data-var-title');
                            if(get_title == get_data){
                                
                                $(ie).addClass('is_active');
                                $(ie).css('display','flex');
                            }else{
                                $(ie).css('display','none');
                                $(ie).removeClass('is_active');
                            }
                            
                        });

                    }
                });                
                oneTime();
                subscribe();
            }else{
                var get_data = readCookie("dog_size");
                var check_val = $('.form__group.form__group--frequency.frequancy_v2 #change_frequancy');
                if(check_val.is(":checked")) {
                    $('.frequency-product .frequency-product__row.sub-save-section').each(function(ix,ie){
                        var get_title = $(ie).find('.frequency-product__col').attr('data-var-title');
                        if(get_title == get_data){                            
                            $(ie).addClass('is_active');
                            $(ie).css('display','flex');      
                        }else{
                            $(ie).css('display','none');
                            $(ie).removeClass('is_active');
                        }
                    });

                    $('.frequency-product__row.sub-save-section.is_active .frequency-product__col').each(function(ix,em){                
                        var get_price = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price');                       
                        var get_price_without_money = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price-wmoney');
                        if($('.add_btn_v2').length){
                            $('.add_btn_v2 .product__price').text(get_price);
                            $('.add_btn_v2 .product__price').attr('data-set-price', get_price_without_money);
                            setTimeout(function() {
                                add_price();
                            }, 200);
                        }       
                    });
                }else{
                    console.log('is one time');
                    $('.frequency-product .frequency-product__row.one-time-section').each(function(ix,ie){
                        var get_title = $(ie).find('.frequency-product__col').attr('data-var-title');
                        if(get_title == get_data){                       
                            $(ie).addClass('is_active');
                            $(ie).css('display','flex');                       
                        }else{
                            $(ie).css('display','none');
                            $(ie).removeClass('is_active');
                        }
                    });

                    $('.frequency-product__row.one-time-section.is_active .frequency-product__col').each(function(ix,em){                
                        var get_price = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price');  
                        var get_price_without_money = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price-wmoney');     
                        
                        if($('.add_btn_v2').length){
                            $('.add_btn_v2 .product__price').text(get_price);
                            $('.add_btn_v2 .product__price').attr('data-set-price', get_price_without_money);
                            setTimeout(function() {
                                add_price();
                            }, 200);
                        }       
                    });
                }
            }
        },100);
        console.log("default size:",default_selected_size);
    }

    // Frequency option one-time
    function oneTime(){
        let default_selected_frequency_one = readCookie("frequency-one");
        let variant_combo_one = `${default_selected_size}--${default_selected_frequency_one}`
        $(document).find(`.frequency-product__row.one-time-section .frequency-product__col .cwr-product-card .form__field input[data-var-combo="${variant_combo_one}"]`).trigger('click');
        if($('.frequency-product.one_time.ld_v2').length){
            $(document).find(`.frequency-product.one_time.ld_v2 .frequency-product__row.one-time-section.is_active .frequency-product__col .cwr-product-card .form__field input[data-var-combo="${variant_combo_one}"]`).trigger('click');
        }
        console.log("one-time",variant_combo_one);
    }

    // Frequency option subscription
    function subscribe(){
        let default_selected_frequency_sub = readCookie("frequency-sub");
        let variant_combo_sub = `${default_selected_size}--${default_selected_frequency_sub}`;
        $(document).find(`.frequency-product__row.sub-save-section .frequency-product__col .cwr-product-card .form__field input[data-var-combo="${variant_combo_sub}"]`).trigger('click');
        if($('.frequency-product.subscribe_save.ld_v2').length){
            $(document).find(`.frequency-product.subscribe_save.ld_v2 .frequency-product__row.sub-save-section.is_active .frequency-product__col .cwr-product-card .form__field input[data-var-combo="${variant_combo_sub}"]`).trigger('click');
        }
        console.log("subscribe",variant_combo_sub);    
    } 

    // call functions
    if($('.form__group.form__group--frequency .form__field').length > 0){        
        mainVariant();
        oneTime();
        subscribe();
    }

    // cookies create function 
    function createCookie(name, value, days) {
        var expires;
    
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }
    // cookies read function 
    function readCookie(name) {
        var nameEQ = encodeURIComponent(name) + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }


    // get default variant id 
    $('.dog-size .form__group.form__group--dog-size .form__field input:checked').each(function(ie,ex){
        var default_varid = $(ex).attr('data-variant-id');
        $('.form--product-details input[name="variantid"]').val(default_varid);
    });

    $(document).on('change','.frequency-product__row.one-time-section .frequency-product__col .cwr-product-card .form__field input', function(){
       
        $('.frequency-product__row.one-time-section.is_active .frequency-product__col').each(function(ix,em){                
             $(em).find('.cwr-product-card .form__field input').prop('checked', false);            
        });
        $(this).prop('checked', true);    

        // create cookies on change
        var get_var_size = $(this).attr('data-variant-size');
        console.log(get_var_size);
        var get_price = $(this).attr('data-variant-price');
        var get_price_without_money = $(this).attr('data-variant-price-wmoney');
        // console.log(variant_combo_sub);   
        if($('.add_btn_v2').length){
            $('.add_btn_v2 .product__price').text(get_price);
            $('.add_btn_v2 .product__price').attr('data-set-price', get_price_without_money);
            setTimeout(function() {
                add_price();
            }, 200);
        }
        createCookie("frequency-one", get_var_size, 30);
        // console.log(variant_combo_one);    
    });

    $(document).on('change','.frequency-product__row.sub-save-section .frequency-product__col .cwr-product-card .form__field input', function(){
        
        $('.frequency-product__row.sub-save-section.is_active .frequency-product__col').each(function(ix,em){                
             $(em).find('.cwr-product-card .form__field input').prop('checked', false);            
        });
        $(this).prop('checked', true);
         
        // create cookies on change
        var get_var_size = $(this).attr('data-variant-size');
        createCookie("frequency-sub", get_var_size, 30);  
        // console.log(variant_combo_sub);   
        var get_price = $(this).attr('data-variant-price');
        var get_price_without_money = $(this).attr('data-variant-price-wmoney');
        // console.log(variant_combo_sub);   
        if($('.add_btn_v2').length){
            $('.add_btn_v2 .product__price').text(get_price);
            $('.add_btn_v2 .product__price').attr('data-set-price', get_price_without_money);
        }
        console.log("change frequency");             
    });

    $(document).on('change','.dog-size .form__group.form__group--dog-size .form__field input',function(){
        var get_dog_size = $(this).attr('data-size-value');
        
         // create cookies on change
         createCookie("dog_size", get_dog_size, 30);
        if($('.form__group.form__group--frequency .form__field').length > 0){
            $('.form__group.form__group--frequency .form__field input[name="select-frequency"]:checked').each(function(ie,ix){
                var get_val = $(ix).attr('data-f-type');
                if(get_val == 'one-time' )           
                {
                    $('.frequency-product .frequency-product__row.one-time-section').each(function(ix,ie){
                        var get_title = $(ie).find('.frequency-product__col').attr('data-var-title');
                        if(get_title == get_dog_size){
                        
                            $(ie).addClass('is_active');
                            $(ie).css('display','flex');
                        }else{
                            $(ie).css('display','none');
                            $(ie).removeClass('is_active');
                        }
                    });
                
                }else{
                    $('.frequency-product .frequency-product__row.sub-save-section').each(function(ix,ie){
                        var get_title = $(ie).find('.frequency-product__col').attr('data-var-title');
                        if(get_title == get_dog_size){
                            
                            $(ie).addClass('is_active');
                            $(ie).css('display','flex');
                        }else{
                            $(ie).css('display','none');
                            $(ie).removeClass('is_active');
                        }
                    });
                }
            });
        }else{
            var check_val = $('.form__group.form__group--frequency.frequancy_v2 #change_frequancy');
            console.log('is change');
            if(check_val.is(":checked")) {
                $('.frequency-product .frequency-product__row.sub-save-section').each(function(ix,ie){
                    var get_title = $(ie).find('.frequency-product__col').attr('data-var-title');
                    if(get_title == get_dog_size){                            
                        $(ie).addClass('is_active');
                        $(ie).css('display','flex');      
                    }else{
                        $(ie).css('display','none');
                        $(ie).removeClass('is_active');
                    }
                });

                $('.frequency-product__row.sub-save-section.is_active .frequency-product__col').each(function(ix,em){                
                    var get_price = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price'); 
                    var get_price_without_money = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price-wmoney');                      
                    if($('.add_btn_v2').length){
                        $('.add_btn_v2 .product__price').text(get_price);
                        $('.add_btn_v2 .product__price').attr('data-set-price', get_price_without_money);
                        setTimeout(function(){
                            add_price();
                        },00);                        
                    }       
                });
            }else{
                $('.frequency-product .frequency-product__row.one-time-section').each(function(ix,ie){
                    var get_title = $(ie).find('.frequency-product__col').attr('data-var-title');
                    if(get_title == get_dog_size){                       
                        $(ie).addClass('is_active');
                        $(ie).css('display','flex');                       
                    }else{
                        $(ie).css('display','none');
                        $(ie).removeClass('is_active');
                    }
                });

                $('.frequency-product__row.one-time-section.is_active .frequency-product__col').each(function(ix,em){                
                    var get_price = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price');  
                    var get_price_without_money = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price-wmoney'); 
                    if($('.add_btn_v2').length){
                        $('.add_btn_v2 .product__price').text(get_price);
                        $('.add_btn_v2 .product__price').attr('data-set-price', get_price_without_money);
                        setTimeout(function() {
                            add_price();
                        }, 200);
                    }       
               });
            }
        }
    });

    $(document).on('change','.form__group--frequency .form__field input', function(){
        var freq_type = $(this).attr('data-f-type')
        if(freq_type == 'one-time'){
            $('.frequency-product.one_time').show();
            $('.frequency-product.subscribe_save').hide();
            // call function on one-time mode
            mainVariant();
            oneTime();
            console.log("one");
        }else{
            $('.frequency-product.one_time').hide();
            $('.frequency-product.subscribe_save').show();
            // call function on subscribe mode
            mainVariant();
            subscribe();
            console.log("sub");
        }

    });

    $(".form--product-details").submit(function(e){
        e.preventDefault();
        if($('.form__group.form__group--frequency .form__field').length){
            $('.form__group.form__group--frequency .form__field input[name="select-frequency"]:checked').each(function(ie,ix){
                var get_val = $(ix).attr('data-f-type');
                if(get_val == 'one-time' )           
                {   
                    var itemsArray = [];
                    var line_properties = {};
                    var dt = new Date();
                    var time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
                    // line_properties.text_value = 'Extra Product' + time;
                    // line_properties.main_product = 'Main Product';
                    $('.frequency-product .frequency-product__row.one-time-section.is_active .frequency-product__col').each(function(el,ex){
                        var em = $(ex).find('.cwr-product-card .form__field input');
                        if(em.is(':checked')) {                     
                            var var_id  = em.attr('data-variant-id');
                            var customItem = { id: var_id, quantity: 1 };
                            itemsArray.push(customItem);

                            $('.cwr-product-details__extra-product-slider .cwr-product-details__extra-product-slide').each(function(ie,ix){
                                var emnew =   $(ix).find('.cwr-product-card-new');              
                                if(emnew.hasClass('is-selected')){                                 
                                    var var_id  = emnew.attr('data-current-varaintid');    
                                    var extraitems = { id: var_id, quantity: 1};
                                    itemsArray.push(extraitems);
                                }
                            });
                        }
                    });

                    $.ajax({
                        url: '/cart/add.js',
                        method: "POST",
                        dataType: "JSON",
                        data: { items: itemsArray },
                        success: function (data) {
                                var shop_url = $('.cwr-product-details').attr('data-shop-url');
                                //window.location.href = shop_url + "/cart";
                                 //window.location.href = shop_url + "/cart";
                                 $.getJSON('/cart.js', function(data) {
                                    let cart_count = data.item_count;
                                
                                    // Check if .cart__count exists, if not, create it inside #dCartBtn as the last child
                                    if ($('.cart__count').length === 0) {
                                        $('#dCartBtn').append('<span class="cart__count"></span>');
                                    }
                                
                                    // Update .cart__count content if the element exists and cart_count is a number
                                    if (cart_count !== undefined && typeof cart_count === "number") {
                                        $('.cart__count').html(cart_count);
                                    }
                                }).fail(function(error) {
                                    console.error('Error fetching cart data:', error);
                                });

                                // Twitter conversion tracking event code
                                console.log('twitter script is loaded')
                                twq('event', 'tw-ol9ny-ol9ot', {
                                });
                                // End Twitter conversion tracking event code
                        },
                        error: function (data) {
                        }
                    });

                }else{
                    var itemsArray = [];
                    
                    var line_properties = {};
                    var dt = new Date();
                    var time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
                    // line_properties.text_value = 'Extra Product' + time;
                    // line_properties.main_product = 'Main Product';
                    $('.frequency-product .frequency-product__row.sub-save-section.is_active .frequency-product__col').each(function(el,ex){
                        var em = $(ex).find('.cwr-product-card .form__field input');  
                        if(em.is(':checked')) {     
                            var var_id  = em.attr('data-variant-id');
                            var product_id = em.attr('data-product-id');
                            var selling_plan_id = $(ex).find('.cwr-product-card__content').attr('data-selling-id');
                            const subscriptionProducts = [8034003386618,8035076767994,8035077128442,8035077652730];
                            var customItem = { id: var_id, quantity: 1, selling_plan: selling_plan_id};

                             // 👇 For specific products 
                            if(Shopify && Shopify.country === "CA" &&  subscriptionProducts.includes(parseInt(product_id))){
                                customItem.properties = {
                                    _is_selling_plan: "true"
                                };
                            }

                            itemsArray.push(customItem);

                            $('.cwr-product-details__extra-product-slider .cwr-product-details__extra-product-slide').each(function(ie,ix){
                                var emnew =   $(ix).find('.cwr-product-card-new');              
                                if(emnew.hasClass('is-selected')){                                       
                                var var_id  = emnew.attr('data-current-varaintid');    
                                    var extraitems = { id: var_id, quantity: 1 };
                                    itemsArray.push(extraitems);
                                }
                            });
                        }
                    });

                    $.ajax({
                        url: '/cart/add.js',
                        method: "POST",
                        dataType: "JSON",
                        data: { items: itemsArray },
                        success: function (data) {
                                var shop_url = $('.cwr-product-details').attr('data-shop-url');
                                //window.location.href = shop_url + "/cart";
                                $.getJSON('/cart.js', function(data) {
                                    let cart_count = data.item_count;
                                
                                    // Check if .cart__count exists, if not, create it inside #dCartBtn as the last child
                                    if ($('.cart__count').length === 0) {
                                        $('#dCartBtn').append('<span class="cart__count"></span>');
                                    }
                                
                                    // Update .cart__count content if the element exists and cart_count is a number
                                    if (cart_count !== undefined && typeof cart_count === "number") {
                                        $('.cart__count').html(cart_count);
                                    }
                                }).fail(function(error) {
                                    console.error('Error fetching cart data:', error);
                                });

                                // Twitter conversion tracking event code
                                console.log('twitter script is loaded')
                                twq('event', 'tw-ol9ny-ol9ot', {
                                });
                                // End Twitter conversion tracking event code
                        },
                        error: function (data) {
                        }
                    });

                }
            });
        }else{
            var check_val = $('.form__group.form__group--frequency.frequancy_v2 #change_frequancy');
            if(check_val.is(":checked")) {
                var itemsArray = [];
                    
                    var line_properties = {};
                    var dt = new Date();
                    var time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
                    // line_properties.text_value = 'Extra Product' + time;
                    // line_properties.main_product = 'Main Product';
                    $('.frequency-product .frequency-product__row.sub-save-section.is_active .frequency-product__col').each(function(el,ex){
                        var em = $(ex).find('.cwr-product-card .form__field input');  
                        if(em.is(':checked')) {     
                            var var_id  = em.attr('data-variant-id');
                            var selling_plan_id = $(ex).find('.cwr-product-card__content').attr('data-selling-id');
                            var customItem = { id: var_id, quantity: 1, selling_plan: selling_plan_id};
                            itemsArray.push(customItem);

                            $('.cwr-product-details__extra-product-slider .cwr-product-details__extra-product-slide').each(function(ie,ix){
                                var emnew =   $(ix).find('.cwr-product-card-new');              
                                if(emnew.hasClass('is-selected')){                                       
                                var var_id  = emnew.attr('data-current-varaintid');    
                                    var extraitems = { id: var_id, quantity: 1};
                                    itemsArray.push(extraitems);
                                }
                            });
                        }
                    });

                    $.ajax({
                        url: '/cart/add.js',
                        method: "POST",
                        dataType: "JSON",
                        data: { items: itemsArray },
                        success: function (data) {
                                var shop_url = $('.cwr-product-details').attr('data-shop-url');
                                //window.location.href = shop_url + "/cart";
                                $.getJSON('/cart.js', function(data) {
                                    let cart_count = data.item_count;
                                
                                    // Check if .cart__count exists, if not, create it inside #dCartBtn as the last child
                                    if ($('.cart__count').length === 0) {
                                        $('#dCartBtn').append('<span class="cart__count"></span>');
                                    }
                                
                                    // Update .cart__count content if the element exists and cart_count is a number
                                    if (cart_count !== undefined && typeof cart_count === "number") {
                                        $('.cart__count').html(cart_count);
                                    }
                                }).fail(function(error) {
                                    console.error('Error fetching cart data:', error);
                                });

                                // Twitter conversion tracking event code
                                console.log('twitter script is loaded')
                                twq('event', 'tw-ol9ny-ol9ot', {
                                });
                                // End Twitter conversion tracking event code
                        },
                        error: function (data) {
                        }
                    });
            }else{
                var itemsArray = [];
                var line_properties = {};
                var dt = new Date();
                var time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
                // line_properties.text_value = 'Extra Product' + time;
                // line_properties.main_product = 'Main Product';
                $('.frequency-product .frequency-product__row.one-time-section.is_active .frequency-product__col').each(function(el,ex){
                    var em = $(ex).find('.cwr-product-card .form__field input');
                    if(em.is(':checked')) {                     
                        var var_id  = em.attr('data-variant-id');
                        var customItem = { id: var_id, quantity: 1};
                        itemsArray.push(customItem);

                        $('.cwr-product-details__extra-product-slider .cwr-product-details__extra-product-slide').each(function(ie,ix){
                            var emnew =   $(ix).find('.cwr-product-card-new');              
                            if(emnew.hasClass('is-selected')){                                 
                                var var_id  = emnew.attr('data-current-varaintid');    
                                var extraitems = { id: var_id, quantity: 1};
                                itemsArray.push(extraitems);
                            }
                        });
                    }
                });

                $.ajax({
                    url: '/cart/add.js',
                    method: "POST",
                    dataType: "JSON",
                    data: { items: itemsArray },
                    success: function (data) {
                            var shop_url = $('.cwr-product-details').attr('data-shop-url');
                            //window.location.href = shop_url + "/cart";
                            $.getJSON('/cart.js', function(data) {
                                let cart_count = data.item_count;
                            
                                // Check if .cart__count exists, if not, create it inside #dCartBtn as the last child
                                if ($('.cart__count').length === 0) {
                                    $('#dCartBtn').append('<span class="cart__count"></span>');
                                }
                            
                                // Update .cart__count content if the element exists and cart_count is a number
                                if (cart_count !== undefined && typeof cart_count === "number") {
                                    $('.cart__count').html(cart_count);
                                }
                            }).fail(function(error) {
                                console.error('Error fetching cart data:', error);
                            });

                            // Twitter conversion tracking event code
                            console.log('twitter script is loaded')
                            twq('event', 'tw-ol9ny-ol9ot', {
                            });
                            // End Twitter conversion tracking event code
                    },
                    error: function (data) {
                    }
                });
            }
        }
    });

    $(document).on('click','.add_variant', function(){
        var get_id = $(this).attr('data-var-id');
        console.log(get_id);
        $(this).parents('.cwr-product-card-new').toggleClass('is-selected');
        $(this).toggleClass('active');
        $(this).next('span').text('-');
        var addon_price = parseInt($(this).attr('data-variant-price'));
        
        if($('.cwr-btn__text.cwr-btn--primary__text.add_btn_v2').length){
            var get_price = parseInt($('.cwr-btn__text.cwr-btn--primary__text.add_btn_v2 .product__price').attr('data-set-price'));           
            let sum_of = 0;
            $('.cwr-product-details__extra-product-slider .cwr-product-details__extra-product-slide').each(function(index, em) {
                // Add the current value to the sum
                var get_num = $(em).find('.cwr-product-card-new .cwr-product-card__content .add_variant');
                if($(get_num).hasClass('active')){
                    console.log(get_num + 'get_num');
                    var is_price = parseInt($(get_num).attr('data-variant-price'));
                    console.log(is_price);
                    sum_of  += is_price;                  
                }
            });
            if($(this).hasClass( "active" )){                
                var total_update = sum_of + get_price;  
                var formattedMoney = Shopify.formatMoney(total_update, "${{amount}}");          
                if($('.add_btn_v2').length){
                    $('.add_btn_v2 .product__price').text(formattedMoney);
                    $('.add_btn_v2 .product__price').attr('data-without_money', total_update);
                } 
            }else{
                var without_money = parseInt($('.cwr-btn__text.cwr-btn--primary__text.add_btn_v2 .product__price').attr('data-without_money'));
                var total_of = without_money - addon_price;
                var formattedMoney_minus = Shopify.formatMoney(total_of, "${{amount}}");
                if($('.add_btn_v2').length){
                    $('.add_btn_v2 .product__price').text(formattedMoney_minus);
                    $('.add_btn_v2 .product__price').attr('data-without_money', total_of);
                } 
            } 
        }  
    });

    $(document).on('click', '.col-quantity .remove a', function(e){
        e.preventDefault();
        var get_url = $(this).attr('href');
        var get_attr = $(this).attr('data-item-main-properties');
        var get_text_val = $(this).attr('data-item-properties');
        var  pro_title = $(this).attr('data-pro-title');
        if( get_attr !== "" ){
            $('.cwr-modal').show();
            $('.cwr-modal .remove_product').attr('data-item-main-properties',get_attr);
            $('.cwr-modal .remove_product').attr('data-item-properties',get_text_val);
            $('.cwr-modal .cwr-modal__content p .product_title').text(pro_title);

        }else{
            window.location.replace(get_url);
        }     
    });

    $(document).on('click', '.cwr-modal__btns .close_popup', function(e){
        e.preventDefault();
        $('.cwr-modal').hide();
    });

    $('.cwr-modal__btns .remove_product').on('click', function(e){
        e.preventDefault();
        var get_attr = $(this).attr('data-item-main-properties');
        console.log('get attr-' + get_attr);
        var get_text_val = $(this).attr('data-item-properties');
        var itemsArray  = {};
        $.getJSON('/cart.json', function(cartdata) {
            $(cartdata.items).each(function (ix, em) {
                var item_id = em.variant_id;
                $(em.properties).each(function (ix, em2) {
                    var get_lineitem = em2.text_value;
                    console.log('line-text-' + get_lineitem);
                    console.log('text-valu-' + get_text_val);
                    if(get_lineitem == "undefined"){
                        itemsArray[item_id] = 0;
                        console.log('is not matched');
                    }else{                     
                        if(get_lineitem == get_text_val){
                            itemsArray[item_id] = 0;
                            console.log('is matched');
                            console.log('is array '+ itemsArray );
                        }
                    }
                });                    
            });

           //Update.js
            $.ajax({
                url: "/cart/update.js",
                data: { updates: itemsArray },
                method: "POST",
                dataType: "JSON",
                success: function (data) {
                    location.reload(true);
                }, error: function (error) {
                    
            }
            });
        });
    });

    $(document).on('click', '.cwr-modal__btns .close_popup', function(e){
        e.preventDefault();
        $('.cwr-modal').hide();
    });

    $('.cwr-modal__btns .remove_product').on('click', function(e){
        e.preventDefault();
        var get_attr = $(this).attr('data-item-main-properties');
        console.log('get attr-' + get_attr);
        var get_text_val = $(this).attr('data-item-properties');
        var itemsArray  = {};
        $.getJSON('/cart.json', function(cartdata) {
            $(cartdata.items).each(function (ix, em) {
                var item_id = em.variant_id;
                $(em.properties).each(function (ix, em2) {
                    var get_lineitem = em2.text_value;
                    console.log('line-text-' + get_lineitem);
                    console.log('text-valu-' + get_text_val);
                    if(get_lineitem == "undefined"){
                        itemsArray[item_id] = 0;
                        console.log('is not matched');
                    }else{                     
                        if(get_lineitem == get_text_val){
                            itemsArray[item_id] = 0;
                            console.log('is matched');
                            console.log('is array '+ itemsArray );
                        }
                    }
                });                    
            });

           //Update.js
            $.ajax({
                url: "/cart/update.js",
                data: { updates: itemsArray },
                method: "POST",
                dataType: "JSON",
                success: function (data) {
                    location.reload(true);
                }, error: function (error) {
                    
            }
            });
        });
    });


    $('.frequency-product__row.sub-save-section.is_active .frequency-product__col').each(function(ix,em){                
        var get_price = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price'); 
        var get_price_without_money = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price-wmoney');      
        if($('.add_btn_v2').length){
            $('.add_btn_v2 .product__price').text(get_price);
            $('.add_btn_v2 .product__price').attr('data-set-price', get_price_without_money);
        }       
   });

    $(document).on('change','.cwr-product-detailsv2 .frequancy_v2.form__group input',function(){
        if (this.checked) {
            $('.frequency-product__row.sub-save-section.is_active .frequency-product__col').each(function(ix,em){                
                    var get_price = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price');
                    var get_price_without_money = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price-wmoney');  
                        
                    if($('.add_btn_v2').length){
                        $('.add_btn_v2 .product__price').text(get_price);
                        $('.add_btn_v2 .product__price').attr('data-set-price', get_price_without_money);                    
                    }       
            });
            mainVariant();
        }else{
                console.log('onetime');
                $('.frequency-product__row.one-time-section.is_active .frequency-product__col').each(function(ix,em){                
                    var get_price = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price'); 
                    var get_price_without_money = $(em).find('.cwr-product-card .form__field input:checked').attr('data-variant-price-wmoney');      
                    if($('.add_btn_v2').length){
                        $('.add_btn_v2 .product__price').text(get_price);
                        $('.add_btn_v2 .product__price').attr('data-set-price', get_price_without_money);
                        
                    }       
            });
            mainVariant();
        }
    });

    $(document).on('change','#change_frequancy', function() {
        if(this.checked) {
          $('.frequency-product.one_time.ld_v2').hide();
          $('.frequency-product.subscribe_save.ld_v2').show();
        }else{
          $('.frequency-product.one_time.ld_v2').show();
          $('.frequency-product.subscribe_save.ld_v2').hide();
        }
      });

      // Price Update function
    function add_price(){
        var totalSum = 0;
        $('.cwr-product-details__extra-product-slider .cwr-product-details__extra-product-slide').each(function(index, em) {
            // Add the current value to the sum
            var get_num = $(em).find('.cwr-product-card-new .cwr-product-card__content .add_variant');
            if($(get_num).hasClass('active')){
                console.log(get_num + 'get_num');
                var is_price = parseInt($(get_num).attr('data-variant-price'));
                console.log(is_price);
                totalSum  += is_price;                  
            }
        });
        
        console.log('totalSum ' + totalSum);  
        var set_price = parseInt($('.add_btn_v2 .product__price').attr('data-set-price'));
        var update_price = set_price + totalSum;              
        var formate_price = Shopify.formatMoney(update_price, "${{amount}}");    
        console.log(formate_price);
        if($('.add_btn_v2').length){
            $('.add_btn_v2 .product__price').text(formate_price);
            $('.add_btn_v2 .product__price').attr('data-without_money', update_price);                    
        } 
    }
});